module.exports = __webpack_public_path__ + "static/img/01.6ca7ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/01.png
// module id = MmxM
// module chunks = 1